<template>
  <div v-if="visible" class="orientation-overlay">
    <div class="orientation-overlay__inner">
      <div class="orientation-overlay__icon">
        <svg
          v-if="mode === 'narrow'"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-2 0 26 24"
          width="72"
          height="72"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="5" y="8" width="18" height="10" rx="2" />
          <path d="M7 21a8 8 0 0 1 0-16" />
          <polyline points="5 3 7 5 5 7" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="72"
          height="72"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="12" y1="3" x2="12" y2="21" />
          <polyline points="7 7 12 3 17 7" />
          <polyline points="7 17 12 21 17 17" />
        </svg>
      </div>
      <div class="orientation-overlay__text">{{ message }}</div>
    </div>
  </div>
</template>

<script>
// 寬高比有效區間：低於下限 → 太窄/直向；高於上限 → 太扁
// 1.2 涵蓋 iPad 4:3 橫向 (1.33)；2.5 涵蓋手機 19.5:9 (2.17) 與 21:9 超寬螢幕 (2.33)
const MIN_ASPECT_RATIO = 1.1;
const MAX_ASPECT_RATIO = 3.5;

export default {
  name: "OrientationOverlay",
  data() {
    return {
      visible: false,
      mode: "narrow", // 'narrow' | 'flat'
      resizeTimer: null,
    };
  },
  computed: {
    message() {
      return this.mode === "narrow"
        ? "請將畫面調整為橫向，或加寬瀏覽器視窗"
        : "畫面過扁，請增加視窗高度";
    },
  },
  mounted() {
    this.evaluate();
    window.addEventListener("resize", this.onResize);
    window.addEventListener("orientationchange", this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("orientationchange", this.onResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  methods: {
    onResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(this.evaluate, 100);
    },
    evaluate() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      if (h <= 0) {
        this.visible = false;
        return;
      }
      const ratio = w / h;
      if (ratio < MIN_ASPECT_RATIO) {
        this.mode = "narrow";
        this.visible = true;
      } else if (ratio > MAX_ASPECT_RATIO) {
        this.mode = "flat";
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
  },
};
</script>

<style scoped>
.orientation-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background-color: #61005f;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  /* iOS Safari notch */
  padding-top: env(safe-area-inset-top, 24px);
  padding-bottom: env(safe-area-inset-bottom, 24px);
}
.orientation-overlay__inner {
  text-align: center;
  max-width: 320px;
}
.orientation-overlay__icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}
.orientation-overlay__text {
  font-size: 18px;
  line-height: 1.5;
}
</style>
